module.exports = __webpack_public_path__ + "static/media/antic-mobiles-tiny.8bc59c32.jpg";